
//import '../../scss/master.scss';

import '../../lib/jquery.extendable.js';
import '../../lib/jquery.nivasSelect.js';

import PhotoSwipeUI_Default from '../../lib/photoswipe-ui-default.min.js';
import PhotoSwipe from '../../lib/photoswipe.min.js';

import _ from 'underscore';

import JQuery from 'jquery';


import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import TextOnPath from "../../lib/textOnPath";




// Preload fonts and images
Promise.all([]).then(() => {
    // And then initialize the TextOnScroll instances
    [...document.querySelectorAll('svg.svgtext')].forEach(el => new TextOnPath(el));
    // Remove loader (loading class)

});


// for Vue
window.$ = window.JQuery = JQuery;

var isMobile = {
	Android: function() {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function() {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function() {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	iPad: function() {
		return navigator.userAgent.match(/iPad/i);
	},
	Opera: function() {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function() {
		return navigator.userAgent.match(/IEMobile/i);
	},
	any: function() {
		return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.iPad() || isMobile.Opera() || isMobile.Windows());
	}
};


// Cookie
var VuduGdprPlugin = {


	options: {
		'necessary': {
			cookieName: 'gdpr_level_1_necessary',
			pristine: true,
			disabled: true,
			checked: true,
			el: 'gdpr_settings_choice_necessary'
		},
		'analytical': {
			cookieName: 'gdpr_level_2_analytical',
			pristine: true,
			disabled: false,
			checked: false,
			el: 'gdpr_settings_choice_analytical'
		},
		'marketing': {
			cookieName: 'gdpr_level_3_marketing',
			pristine: true,
			disabled: false,
			checked: false,
			el: 'gdpr_settings_choice_marketing'
		}
	},

	init: function () {


		if ($('#gdpr_toolbar').length) {
			this.bindEvent();

			var pristine = true;
			for (var i in VuduGdprPlugin.options) {
				var usersSelection = VuduGdprPlugin.options[i];

				var cookieValue = VuduGdprPlugin.getCookie(usersSelection.cookieName);
				if (cookieValue == 1) {
					pristine = false;

					if (usersSelection.disabled === false) {
						VuduGdprPlugin.options[i].checked = true;

						$("#" + usersSelection.el).prop("checked", true);
					}
				}
				else if (cookieValue == 0) {
					pristine = false;

					if (usersSelection.disabled === false) {
						VuduGdprPlugin.options[i].checked = false;

						$("#" + usersSelection.el).prop("checked", false);
					}
				}

			}

			if (pristine == false) {
				$("#js-toogle-gdpr").addClass("show");
				VuduGdprPlugin.hideToolbar();
			}
            else
			{
				$("#gdpr_toolbar").removeClass("hide");
			}
		}


	},

	bindEvent: function () {

		$('#gdpr_toolbar .x_submit_necessary').on("click", function (e) {
			e.preventDefault();

			VuduGdprPlugin.consentCookie('necessary', true);
			$('#gdpr_settings_choice_necessary').prop("checked", true);
			VuduGdprPlugin.consentCookie('analytical', false);
			$('#gdpr_settings_choice_analytical').prop("checked", false);
			VuduGdprPlugin.consentCookie('marketing', false);
			$('#gdpr_settings_choice_marketing').prop("checked", false);

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});


		$('#gdpr_toolbar .x_submit_all').on("click", function (e) {
			e.preventDefault();

			VuduGdprPlugin.consentCookie('necessary', true);
			$('#gdpr_settings_choice_necessary').prop("checked", true);
			VuduGdprPlugin.consentCookie('analytical', true);
			$('#gdpr_settings_choice_analytical').prop("checked", true);
			VuduGdprPlugin.consentCookie('marketing', true);
			$('#gdpr_settings_choice_marketing').prop("checked", true);

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});

		$('#gdpr_toolbar a.x_open_setup').on("click", function (e) {
			e.preventDefault();

			$('#gdpr_toolbar .gdpr-prompt__ctrl').toggleClass('active');
			$(this).toggleClass('active');
			$('#gdpr_settings_popup').toggleClass('show');
			$('.gdpr-msg').toggleClass('show');
		});

		$('#js-toogle-gdpr').on("click", function (e) {
			e.preventDefault();

			$('#gdpr_toolbar .gdpr-prompt__ctrl').removeClass('active');
			VuduGdprPlugin.showToolbar();
		});

		$("#gdpr_toolbar .x_submit_selected").on("click", function (e) {
			e.preventDefault();

			$("#gdpr_toolbar input.gdpr_level").each(function (index, item) {
				var name = $(item).val();
				var checked = $(this).prop("checked");
				VuduGdprPlugin.consentCookie(name, checked);
			});

			$('#gdpr_toolbar .gdpr-prompt__ctrl').removeClass('active');
			$('#gdpr_toolbar a.x_open_setup').removeClass('active');

			$('#gdpr-overlay').hide();
			$("#gdpr_settings_popup").removeClass("show");
			$('.gdpr-msg').removeClass("show");
			$('#gdpr_toolbar').addClass("hide");
			$('#js-toogle-gdpr').addClass("show");
		});
	},

	showToolbar: function () {
		$("#gdpr-overlay").show();
		$("#gdpr_toolbar").removeClass('hide');
	},

	hideToolbar: function () {
		$("#gdpr-overlay").hide();
		$("#gdpr_toolbar").addClass('hide');
	},

	consentCookie: function (name, checked) {

		if (VuduGdprPlugin.options[name] !== undefined) {
			var value = checked ? 1 : 0;
			VuduGdprPlugin.setCookie(VuduGdprPlugin.options[name].cookieName, value, 365);
		}
	},

	consentAllCookie: function () {

		for (var i in VuduGdprPlugin.options) {
			var usersSelection = VuduGdprPlugin.options[i];
			VuduGdprPlugin.consentCookie(usersSelection.cookieName, true);
		}
	},

	setLevel: function (lvl) {

		if (typeof (cookieDomainName) != 'undefined' && cookieDomainName) {
			//$.cookie(VuduGdprPlugin.cookieName, lvl, { expires: 365, path: '/', domain: cookieDomainName });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, lvl, 365, cookieDomainName);
		}
		else {
			//$.cookie(VuduGdprPlugin.cookieName, lvl, { expires: 365, path: '/' });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, lvl, 365);
		}
	},

	setMaxLevel: function () {

		if (typeof (cookieDomainName) != 'undefined' && cookieDomainName) {
			//$.cookie(VuduGdprPlugin.cookieName, 4, { expires: 365, path: '/', domain: cookieDomainName });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, 4, 365, cookieDomainName);
		}
		else {
			//$.cookie(VuduGdprPlugin.cookieName, 4, { expires: 365, path: '/' });
			VuduGdprPlugin.setCookie(VuduGdprPlugin.cookieName, 4, 365);
		}
	},

	setCookie: function (cname, cvalue, exdays, domain) {
		var domain = (typeof (domain) != 'undefined' && domain) ? domain : '.';
		var d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		var cookieExpires = "expires=" + d.toUTCString();
		var cookieDomain = "domain=" + domain;
		//document.cookie = cname + "=" + cvalue + ";" + cookieExpires + ";" + cookieDomain + ";path=/";
		document.cookie = cname + "=" + cvalue + ";" + cookieExpires;
	},

	getCookie: function (cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return null;
	}

}



// animated svg text
const textPath = document.querySelector("#text-path");
const h = document.documentElement,
	b = document.body,
	st = 'scrollTop',
	sh = 'scrollHeight';

if(textPath){
	document.addEventListener("scroll", e => {
	let percent = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 15;
	textPath.setAttribute("startOffset", (-percent * 40) + 600)
	});
}




function menuDrop() {

	if ($(window).width() < 1199) {

		if ($(".js-menu-dropdown").length ) {

			$(".js-menu-hamburger").click(function(e){
				e.preventDefault();


				if ($(this).hasClass("is-active")) {
					$(this).removeClass("is-active");
					$(".js-menu-dropdown").removeClass("is-active");
					$(".js-menu-icon").removeClass("is-active");
					$(".js-header").removeClass("is-active");
				}

				else {
					$(this).addClass("is-active");
					$(".js-menu-dropdown").addClass("is-active");
					$(".js-menu-icon").addClass("is-active");
					$(".js-header").addClass("is-active");
				}

			});

		}

	}

}


function menuSubToggle() {

	if ($(window).width() < 1199) {

		$(".js-sub-toogle").on('click touchstart', function(e) {
			e.preventDefault();

			if ($(this).hasClass("is-open")) {
				$(".js-sub-toogle").removeClass("is-open");
				$(this).next(".js-submenu").removeClass("is-open");
				$(this).parent(".js-drop").removeClass("is-open");
			} else {
				$(".js-sub-toogle").removeClass("is-open");
				$(this).addClass("is-open");
				$(this).parent(".js-drop").addClass("is-open");
				$(this).next(".js-submenu").addClass("is-open");

			}
		});
	}
}


const swiper = new Swiper(".mySwiper", {
	modules: [Navigation, Pagination],
	loop: true,
	slidesPerView: 2,
	centeredSlides: true,
    spaceBetween: 20,
	pagination: {
		el: ".test-slider .swiper-pagination",
		type: "fraction",
	},
	navigation: {
		nextEl: ".js-split-nav--next",
		prevEl: ".js-split-nav--prev",
	},

	breakpoints: {
		640: {

		},
		768: {
			spaceBetween: 200,
			slidesPerView: 2,
			centeredSlides: true,
		},
		992: {
		},
	},
});


const roomsSwiper = new Swiper(".roomsSwiper", {
	modules: [Navigation, Pagination],
	loop: true,
	slidesPerView: 1.2,
	spaceBetween: 20,

	pagination: {
		el: ".rooms-slider .swiper-pagination",
		type: "fraction",
	},
	navigation: {
		nextEl: ".js-split-nav--next",
		prevEl: ".js-split-nav--prev",
	},

	breakpoints: {
		640: {

		},
		768: {

		},
		992: {
			spaceBetween: 100,
			slidesPerView: 2,
			centeredSlides: true,
		},
	},
});

const activitySwiper = new Swiper(".activitySwiper", {
	modules: [Navigation, Pagination],
	loop: true,
	slidesPerView: 1.2,
	spaceBetween: 20,

	pagination: {
		el: ".activity-slider .swiper-pagination",
		type: "fraction",
	},
	navigation: {
		nextEl: ".js-split-nav--next",
		prevEl: ".js-split-nav--prev",
	},

	breakpoints: {
		640: {

		},
		768: {

		},
		992: {
			spaceBetween: 100,
			slidesPerView: 2,
			centeredSlides: true,
		},
	},
});


var newsFilter = {
	selector: '.xLoadMore',
	defaultResultContainerSelector: '.xResult',
	resultContainer:{},
	pagerEls:{},

	init: function(){
		this.pagerEls = $(this.selector);
		this.pagerEls.each((el)=>{
			$(el).on('click', function(e){
				e.preventDefault();
				let $this = $(this);
				let s = parseInt($this.attr('s'));
				if(s > 0){
					let pg = (parseInt($this.data('pg')) + 1)  || 2;
					let f = $this.attr('f');

					var resSelector = $this.data('res');
					if (resSelector !== undefined)
						xloadMore.resultContainer = $( resSelector );
					else
						xloadMore.resultContainer = $( xloadMore.defaultResultContainerSelector );

					fwajax.langSegment = lang_segment;
					fwajax.phpExecute({ url:url }, {pg:pg,f:f});
				}
			}.bind(el));
		});
	},
	defaultSuccess: function(data)
	{
		data = JSON.parse(data);
		console.log(data, this);
		if (data.success)
		{
			this.pagerEls.attr('pg', parseInt(this.pagerEl.attr('pg')) + 1 );
			this.resultContainer.append(data.html);
			// revealElement(); //animacija
		}
		else{
			console.log("ERROR");
		}
	}
};

var NivasPhotoSwipe = {

	pswpElement: false,

	init: function() {
		this.pswpElement = document.querySelectorAll('.pswp')[0];
		this.bindGallery();
		this.bindVideo();
	},

	openOverlay: function(images, optionz) {


		var self = this;
		var userOptions = (optionz!==undefined) ? optionz : {};

		var options = {

			overtitle: false,
			title: false,

			index: 0,
			modal: true,
			history: false,
			loop: true,

			// Buttons/elements
			closeEl: true,
			captionEl: true,
			fullscreenEl: false,
			zoomEl: false,
			shareEl: false,
			counterEl: true,
			arrowEl: true,
			preloaderEl: false,

			// close
			escKey: true,
			pinchToClose: false,
			tapToClose: true,
			closeOnVerticalDrag: false,
			verticalDragRange: 1,
			clickToCloseNonZoomable: false,
			closeOnScroll: false,

			showAnimationDuration: 500,
			hideAnimationDuration: 200
		};

		_.extend(options, userOptions);


		var gallery = new PhotoSwipe( self.pswpElement, PhotoSwipeUI_Default, images, options);
		gallery.init();
		gallery.listen('close', function() {
			$(".pswp__container .pswp__item").html("");
		});


		$(".pswp .pswp__head").hide();
		if(options.overtitle || options.title)
		{
			$(".pswp .pswp__head").show();
			$(".pswp .galleryName").html(options.overtitle);
			$(".pswp .galleryDesc").html(options.title);
		}



		return gallery;
	},

	openVideoOverlay: function(html, title, userOptions) {

		// disableScroll.on();

		var self = this;

		html = html===undefined ? '' : html;
		title = title===undefined ? '' : title;

		var userOptions = (userOptions!==undefined && typeof object) ? userOptions : {};
		var options = {
			index: 0,
			modal: true,
			history: false,
			loop: true,

			// Buttons/elements
			closeEl: true,
			captionEl: true,
			fullscreenEl: false,
			zoomEl: false,
			shareEl: false,
			counterEl: true,
			arrowEl: false,
			preloaderEl: false,

			// close
			escKey: false,
			pinchToClose: false,
			tapToClose: true,
			closeOnVerticalDrag: false,
			verticalDragRange: 1,
			clickToCloseNonZoomable: false,
			closeOnScroll: false,

			showAnimationDuration: 500,
			hideAnimationDuration: 200
		};
		_.extend(options, userOptions);


		var items = [{html: html, title: title}];

		var gallery = new PhotoSwipe( self.pswpElement, PhotoSwipeUI_Default, items, options);
		gallery.init();
		gallery.listen('close', function() {
			$(".pswp__container .pswp__item").html("");
			// disableScroll.off();
		});





		return gallery;
	},

	bindVideo: function() {

		if($(".js-trigger-video").length)
		{
			var self = this;

			$(".js-trigger-video").on("click touchtap", function(e){
				e.preventDefault();

				var html = $(this).find(".js-video-iframe").html();
				var title = $(this).find(".js-video-iframe").attr("data-title");
				self.openVideoOverlay(html, title);
			});
		}

		if($(".js-trigger-video-gallery").length)
		{
			var self = this;

			$(".js-trigger-video-gallery").on("click touchtap", function(e){
				e.preventDefault();

				$(".multimedia__item video").each(function(index, item){
					item.pause();
				});

				/*var html = $(this).find(".js-video-iframe").html();
				var title = $(this).find(".js-video-iframe").attr("data-title");
				var pswp = self.openVideoOverlay(html, title);
				pswp.listen('close', function() {
					$(".intro--index video").each(function(index, item){
						item.play();
					});
				});*/

				self.iframes = {};

				var videoContainer = $(this).attr("data-container");
				var pswpElement = document.querySelectorAll('.pswp')[0];
				console.log (videoContainer, 'videoContainer')

				var videos = [];
				$(videoContainer + " .item").each(function(item, index){

					var video = {};
					video.html = $(this).find(".js-video-iframe").html();
					video.title = $(this).find(".js-video-iframe").attr("data-title");
					video.author = "";

					videos.push(video);
				});


				var idx = $(videoContainer + " .item").index(this);

				var options = {
					index: idx,
					history: false,
					closeOnScroll: false,
					overtitle: $(this).attr("data-overtitle"),
					title: $(this).attr("data-title")
				};


				// ga tracking
				//BaskaGtmTracking.trackEvent('Video Gallery', 'open', options.title, 1);

				var pswp = self.openOverlay(videos, options);
				pswp.listen('close', function() {
					$(".intro--index video").each(function(index, item){
						item.play();
					});
				});

			});



			$(document).on("click touchtap", ".js-video", function(e){
				e.preventDefault();

				$(".multimedia__item video").each(function(index, item){
					item.pause();
				});

				self.iframes = {};

				var videoContainer = $(this).closest(".pswp_gallery").find(".multimedia__link").attr("data-container");
				// console.log (videoContainer, 'videoContainer')
				var pswpElement = document.querySelectorAll('.pswp')[0];

				var videos = [];
				$(videoContainer + " .item").each(function(item, index){
					// console.log(this);

					var video = {};
					video.html = $(this).find(".js-video-iframe").html();
					video.title = $(this).find(".js-video-iframe").attr("data-title");
					video.author = "";

					videos.push(video);
				});

				var idx = $(videoContainer + " .item").index(this);

				var options = {
					index: idx,
					history: false,
					closeOnScroll: false,
					overtitle: $(this).attr("data-overtitle"),
					title: $(this).attr("data-title")
				};

				self.openOverlay(videos, options);

			});


		}



	},

	bindGallery: function() {

		var self = this;

		$(document).on("click touchtap", ".js-trigger-gallery", function(e){
			e.preventDefault();
			var imageContainer = "."+$(this).attr("data-container");

			var images = [];
			var itemClass = ' .item'
			if(isMobile.any())itemClass+="_mobile";

			$(imageContainer + itemClass).each(function(item, index){

				var wh = $(this).attr("data-wh").split("x");
				var $img = $(this).find("img");

				var img = {};
				img.src = $img.attr("href");
				img.w = wh[0];
				img.h = wh[1];
				img.title = ($img.attr("alt")===undefined) ? "" : $img.attr("alt");
				img.author = ($img.attr("data-author")===undefined) ? "" : $img.attr("data-author");

				images.push(img);

			});


			var idx = $(imageContainer + itemClass).index(this);

			var options = {
				index: idx,
				history: false,
				closeOnScroll: false,
				overtitle: $(this).attr("data-overtitle"),
				title: $(this).attr("data-title"),
				addCaptionHTMLFn: function(item, captionEl, isFake) {
					if(!item.title) {
						captionEl.children[0].innerText = '';
						return false;
					}
					// captionEl.children[0].innerHTML = item.title +  '<br/><small>Autor: ' + item.author + '</small>';
					captionEl.children[0].innerHTML = item.title;
					return true;
				}
			};

			// ga tracking
			//BaskaGtmTracking.trackEvent('Image Gallery', 'open', options.title, 1);
			// console.log(images, options);
			self.openOverlay(images, options);

		});

		$(document).on("click touchtap", ".js-image", function(e){
			e.preventDefault();

			var $imageContainer = $(this).closest(".pswp_gallery");

			var images = [];
			$imageContainer.find(".js-image").each(function(index, item){

				var wh = $(this).attr("data-wh").split("x");
				var $img = $(this).find("img");

				var img = {};
				img.src = $(this).attr("href");
				img.w = wh[0];
				img.h = wh[1];
				img.title = ($img.attr("alt")===undefined || $img.attr("alt") == "") ? "" : $img.attr("alt") + '<br>';
				img.author = ($img.attr("data-author")===undefined) ? "" :  '<small>Autor: ' + $img.attr("data-author") + '</small>' ;
				img.index = index;


				images.push(img);

			});

			var idx = $imageContainer.find(".js-image").index(this);

			var options = {
				index: idx,
				history: false,
				closeOnScroll: false,
				overtitle: $imageContainer.attr("data-overtitle"),
				title: $imageContainer.attr("data-title"),
				addCaptionHTMLFn: function(item, captionEl, isFake) {

					if(item.title === false) {
						captionEl.children[0].innerText = '';
						return false;
					}

					captionEl.children[0].innerHTML = item.title + item.author;
					return true;
				}
			};

			// ga tracking
			//BaskaGtmTracking.trackEvent('Image Gallery', 'open', options.title, 1);

			self.openOverlay(images, options);

		});

	},
};

function formSelectBind(){
		$('.nvsSel.formSel.remove1st a.selectField').one('click', function(e){
		let el = $(e.target).siblings('ul').find('li')[0];
		el.remove();
	});
	$('.nvsSel.formSel').on('change', function(e){
		var interest = $(e.target).val();
		window.location.href = window.location.href.split(/[?#]/)[0] + '?' + interest + '#form';
	});
}




var navigationOverlay = function() {

	$('.site-header').hover(function(e) {
		$(this).addClass('is-visited');
	}, function(){
		$(this).removeClass('is-visited');
	});
}



function fixedNav() {

	var header = $(".site-header");
	var buttons = $(".cta-hero");
	var fullHeight = $(".hero").height();
	var headerOffset = $('.site-header').offset().top;

	if (headerOffset >= fullHeight ) {
		header.addClass("is-fixed");
		buttons.addClass("is-sticky");
	} else {
		header.removeClass("is-fixed");
		buttons.removeClass("is-sticky");
	}

	$(window).scroll(function() {

		var scroll = $(window).scrollTop();

		if (scroll >= fullHeight ) {
			header.addClass("is-fixed");
			buttons.addClass("is-sticky");
		} else {
			header.removeClass("is-fixed");
			buttons.removeClass("is-sticky");
		}
	});
}


var langDrop = function() {

	$('.js-lang').click(function(e) {

		if ($(this).hasClass("is-open")) {
			$(this).removeClass("is-open");
		} else {
			$(this).addClass("is-open");
		}
	});

}



$(document).ready(function() {
	console.log('App ready!');
	VuduGdprPlugin.init();
	menuDrop();
	menuSubToggle();

	newsFilter.init();
	NivasPhotoSwipe.init();
	
	navigationOverlay();
	fixedNav();
	langDrop();

	
	$('select.nvsSel').each(function(obj){
		
		let $this = $(this);
		let opts = {elementClass:$this.attr('class')}
		$this.nivasSelect(opts);
	});
	
	formSelectBind();

	

});
